// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__3s72Z","label":"Labeled_label__1SSF3","divider":"Labeled_divider__lP94Y"};